'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('uint8arrays/equals'),
    uint8ArrayEquals = _require.equals;

var Message = require('../../message');

var utils = require('../../utils');
/**
 * @typedef {import('peer-id')} PeerId
 */

/**
 * @param {import('../../index')} dht
 */


module.exports = function (dht) {
  var log = utils.logger(dht.peerId, 'rpc:find-node');
  /**
   * Process `FindNode` DHT messages.
   *
   * @param {PeerId} peerId
   * @param {Message} msg
   */

  function findNode(_x, _x2) {
    return _findNode.apply(this, arguments);
  }

  function _findNode() {
    _findNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId, msg) {
      var closer, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              log('start');

              if (!uint8ArrayEquals(msg.key, dht.peerId.id)) {
                _context.next = 5;
                break;
              }

              closer = [{
                id: dht.peerId,
                multiaddrs: dht.libp2p.multiaddrs
              }];
              _context.next = 8;
              break;

            case 5:
              _context.next = 7;
              return dht._betterPeersToQuery(msg, peerId);

            case 7:
              closer = _context.sent;

            case 8:
              response = new Message(msg.type, new Uint8Array(0), msg.clusterLevel);

              if (closer.length > 0) {
                response.closerPeers = closer;
              } else {
                log('handle FindNode %s: could not find anything', peerId.toB58String());
              }

              return _context.abrupt("return", response);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _findNode.apply(this, arguments);
  }

  return findNode;
};